export enum CardStatus {
  ASSIGNED = 'assigned',
  UNASSIGNED = 'un-assigned',
}

export enum CardType {
  CREDIT = 'credit',
  DEBIT = 'debit',
}
